'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var valign = require('../../units/valign.js');
var vdir = require('../../units/vdir.js');
var index = require('../../layouts/VAppContainer/1/index.js');
var index$1 = require('../../layouts/VAutoLayout/index.js');
var index$2 = require('../../components/VSpin/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Loading = function () {
  return React__default["default"].createElement("div", {
    className: "vapp-loading"
  }, React__default["default"].createElement(index["default"], null, React__default["default"].createElement(index$1["default"], {
    vstyle: {
      direction: vdir.VDirection.vertical,
      align: valign.VAlign.center
    },
    className: "home-layout"
  }, React__default["default"].createElement(index$2.VSpin, {
    size: "large"
  }))));
};

exports["default"] = Loading;
